import { render, staticRenderFns } from "./cardModify.vue?vue&type=template&id=507382c2&"
import script from "./cardModify.vue?vue&type=script&lang=ts&"
export * from "./cardModify.vue?vue&type=script&lang=ts&"
import style0 from "./cardModify.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports